import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfigService } from "src/app/services/app-config.service";


class DataTablesResponse {
    data: any[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}

@Injectable({
    providedIn: "root"
})
export class MotivazioniService {
    private apiUrl = `${AppConfigService.env.api_endpoint}${AppConfigService.env.endpoints.inframob}Motivazioni/`;
    constructor(private http: HttpClient) { }
    
    getMotivazioni() {
        return this.http.get<any[]>(
            `${this.apiUrl}`
        );
    }
    getPriorita() {
        return this.http.get<any[]>(
            `${this.apiUrl}priorita`
        );
    }

    getAllDt(dataTablesParameters: any) {
        return this.http.post<DataTablesResponse>(
            `${this.apiUrl}alldt`,
            dataTablesParameters
        );
    }

    getAllPrioritaDt(dataTablesParameters: any) {
        return this.http.post<DataTablesResponse>(
            `${this.apiUrl}priorita/alldt`,
            dataTablesParameters
        );
    }

    insert(s: any) {
        return this.http.post<any>(`${this.apiUrl}`, s);
    }
    insertPriorita(s: any) {
        return this.http.post<any>(`${this.apiUrl}priorita`, s);
    }

    update(s: any) {
        return this.http.put<any>(`${this.apiUrl}${s.id}`, s);
    }
    updatePriorita(s: any) {
        return this.http.put<any>(`${this.apiUrl}priorita/${s.id}`, s);
    }
    delete(id: number) {
        return this.http.delete<any>(`${this.apiUrl}${id}`);
    }
    deletePriorita(id: number) {
        return this.http.delete<any>(`${this.apiUrl}${id}`);
    }

    save(s:any){
        if (s.id)return this.update(s);
        return this.insert(s);
    }
    savePriorita(s:any){
        if (s.id)return this.updatePriorita(s);
        return this.insertPriorita(s);
    }

}
